export const socialMedial = [
    {
        name: "Facebook",
        link: "https://www.facebook.com/24Telemed-Limited",
        icon: "fab fa-facebook-f",
        className: "facebook",
    },
    {
        name: "Instagram",
        link: "https://www.instagram.com/24telemed__limited/",
        icon: "fab fa-instagram",
        className: "instagram",
    },
];